import gridhelper from "../views/gridhelper";
import _ from 'lodash';

let counter = 1;

// function getStaticColumns() {
//   return [
//     {
//       field: "dynamicFields_originalTitle",
//       header: "Originaltitle",
//       headerStyle: "width: 150px",
//       isDropDownFilter: false,
//       isTextFilter: true,
//       getter: gridhelper.renderDefault
//     }, {
//       field: "dynamicFields_costUnitNumber",
//       header: "Karinanumber",
//       headerStyle: "width: 150px",
//       isDropDownFilter: false,
//       isTextFilter: true,
//       getter: gridhelper.renderDefault
//     }, {
//       field: "globalTrafficLight",
//       header: "Overall",
//       headerStyle: "width: 150px",
//       isDropDownFilter: true,
//       isTextFilter: false,
//       getter: gridhelper.renderTrafficLight
//     },
//     {
//       field: "dynamicFields_productionType",
//       header: "Type",
//       headerStyle: "width: 100px",
//       isDropDownFilter: true,
//       isTextFilter: false,
//       getter: gridhelper.renderDefault
//     },
//     {
//       field: "dynamicFields_countriesOfProduction",
//       header: "Production countries",
//       headerStyle: "width: 150px",
//       isDropDownFilter: true,
//       isTextFilter: false,
//       getter: gridhelper.renderDefault
//     },
//     {
//       field: "dynamicFields_originalLanguage",
//       header: "Original language",
//       headerStyle: "width: 150px",
//       isDropDownFilter: true,
//       isTextFilter: false,
//       getter: gridhelper.renderDefault
//     },
//     {
//       field: "dynamicFields_color",
//       header: "Color",
//       headerStyle: "width: 150px",
//       isDropDownFilter: true,
//       isTextFilter: false,
//       getter: gridhelper.renderDefault
//     },
//     {
//       field: "dynamicFields_parentalGuidance",
//       header: "PG",
//       headerStyle: "width: 100px",
//       isDropDownFilter: true,
//       isTextFilter: false,
//       getter: gridhelper.renderDefault
//     },
//     {
//       field: "dynamicFields_client",
//       header: "Client",
//       headerStyle: "width: 100px",
//       isDropDownFilter: false,
//       isTextFilter: true,
//       getter: gridhelper.renderDefault
//     },
//     {
//       field: "dynamicFields_directors",
//       header: "Directors",
//       headerStyle: "width: 150px",
//       isDropDownFilter: false,
//       isTextFilter: true,
//       getter: gridhelper.renderDefault
//     },
//     {
//       field: "dynamicFields_actors",
//       header: "Actors",
//       headerStyle: "width: 150px",
//       isDropDownFilter: false,
//       isTextFilter: true,
//       getter: gridhelper.renderDefault
//     },
//     {
//       field: "dynamicFields_book",
//       header: "Book",
//       headerStyle: "width: 150px",
//       isDropDownFilter: false,
//       isTextFilter: true,
//       getter: gridhelper.renderDefault
//     },
//     {
//       field: "dynamicFields_productionNumber",
//       header: "dynamicFields_productionNumber",
//       headerStyle: "width: 150px",
//       isDropDownFilter: true,
//       isTextFilter: false,
//       getter: gridhelper.renderDefault
//     },
//     {
//       field: "dynamicFields_productionYear",
//       header: "dynamicFields_productionYear",
//       headerStyle: "width: 150px",
//       isDropDownFilter: true,
//       isTextFilter: false,
//       getter: gridhelper.renderDefault
//     },
//     {
//       field: "dynamicFields_seasonNo",
//       header: "dynamicFields_seasonNo",
//       headerStyle: "width: 150px",
//       isDropDownFilter: true,
//       isTextFilter: false,
//       getter: gridhelper.renderDefault
//     },
//     {
//       field: "dynamicFields_seriesTitle",
//       header: "dynamicFields_seriesTitle",
//       headerStyle: "width: 150px",
//       isDropDownFilter: true,
//       isTextFilter: false,
//       getter: gridhelper.renderDefault
//     },
//     {
//       field: "dynamicFields_baseType",
//       header: "dynamicFields_baseType",
//       headerStyle: "width: 150px",
//       isDropDownFilter: true,
//       isTextFilter: false,
//       getter: gridhelper.renderDefault
//     },
//     {
//       field: "dynamicFields_subGenre",
//       header: "dynamicFields_subGenre",
//       headerStyle: "width: 150px",
//       isDropDownFilter: true,
//       isTextFilter: false,
//       getter: gridhelper.renderDefault
//     },
//     {
//       field: "dynamicFields_duration",
//       header: "dynamicFields_duration",
//       headerStyle: "width: 150px",
//       isDropDownFilter: true,
//       isTextFilter: false,
//       getter: gridhelper.renderDefault
//     },
//     {
//       field: "dynamicFields_castCrew",
//       header: "dynamicFields_castCrew",
//       headerStyle: "width: 150px",
//       isDropDownFilter: false,
//       isTextFilter: true,
//       getter: gridhelper.renderDefault
//     },
//     // {field:"dynamicFields_genre",header:"dynamicFields_genre",headerStyle:"width: 150px",isDropDownFilter:true,isTextFilter:false, getter: gridhelper.renderDefault},
//     {
//       field: "dynamicFields_customGenre",
//       header: "dynamicFields_genre",
//       headerStyle: "width: 150px",
//       isDropDownFilter: true,
//       isTextFilter: false,
//       getter: gridhelper.renderDefault
//     },
//     {
//       field: "dynamicFields_format",
//       header: "dynamicFields_format",
//       headerStyle: "width: 150px",
//       isDropDownFilter: true,
//       isTextFilter: false,
//       getter: gridhelper.renderDefault
//     },
//     {
//       field: "dynamicFields_productionYearEnd",
//       header: "dynamicFields_productionYearEnd",
//       headerStyle: "width: 150px",
//       isDropDownFilter: true,
//       isTextFilter: false,
//       getter: gridhelper.renderDefault
//     },
//     {
//       field: "dynamicFields_keyword",
//       header: "dynamicFields_keyword",
//       headerStyle: "width: 150px",
//       isDropDownFilter: false,
//       isTextFilter: true,
//       getter: gridhelper.renderDefault
//     },
//     {
//       field: "dynamicFields_countDuration",
//       header: "dynamicFields_countDuration",
//       headerStyle: "width: 150px",
//       isDropDownFilter: true,
//       isTextFilter: false,
//       getter: gridhelper.renderDefault
//     },
//     {
//       field: "dynamicFields_nationalTitle",
//       header: "dynamicFields_nationalTitle",
//       headerStyle: "width: 150px",
//       isDropDownFilter: false,
//       isTextFilter: true,
//       getter: gridhelper.renderDefault
//     },
//     {
//       field: "dynamicFields_episodeNo",
//       header: "dynamicFields_episodeNo",
//       headerStyle: "width: 150px",
//       isDropDownFilter: true,
//       isTextFilter: false,
//       getter: gridhelper.renderDefault
//     },
//     {
//       field: "dynamicFields_customQualificationCsa",
//       header: "dynamicFields_qualificationCsa",
//       headerStyle: "width: 150px",
//       isDropDownFilter: true,
//       isTextFilter: false,
//       getter: gridhelper.renderDefault
//     },
//     {
//       field: "dynamicFields_customOriginalLanguageCsa",
//       header: "dynamicFields_originalLanguageCsa",
//       headerStyle: "width: 150px",
//       isDropDownFilter: true,
//       isTextFilter: false,
//       getter: gridhelper.renderDefault
//     },
//     {
//       field: "dynamicFields_customAllRights",
//       header: "dynamicFields_allRights",
//       headerStyle: "width: 150px",
//       isDropDownFilter: true,
//       isTextFilter: false,
//       getter: gridhelper.renderBoolean
//     },
//     {
//       field: "dynamicFields_customProductPlacement",
//       header: "dynamicFields_productPlacement",
//       headerStyle: "width: 150px",
//       isDropDownFilter: true,
//       isTextFilter: false,
//       getter: gridhelper.renderBoolean
//     },
//     {
//       field: "dynamicFields_customFinal43",
//       header: "dynamicFields_final43",
//       headerStyle: "width: 150px",
//       isDropDownFilter: true,
//       isTextFilter: false,
//       getter: gridhelper.renderBoolean
//     },
//     {
//       field: "dynamicFields_customParentalGuidanceMain",
//       header: "dynamicFields_customParentalGuidanceMain",
//       headerStyle: "width: 150px",
//       isDropDownFilter: false,
//       isTextFilter: true,
//       getter: gridhelper.renderDefault
//     },
//     {
//       field: "dynamicFields_customParentalGuidanceAll",
//       header: "dynamicFields_customParentalGuidanceAll",
//       headerStyle: "width: 150px",
//       isDropDownFilter: false,
//       isTextFilter: true,
//       getter: gridhelper.renderDefault
//     },
//     {
//       field: "dynamicFields_customRecommendation",
//       header: "dynamicFields_customRecommendation",
//       headerStyle: "width: 150px",
//       isDropDownFilter: false,
//       isTextFilter: true,
//       getter: gridhelper.renderDefault
//     }
//   ]
// }


function generateTrafficLightCols(count) {
  let lights = [];
  for (let i = 0; i < count; i++) {
    lights.push(
      {
        field: "trafficLights_" + i + "_trafficLightColor_0",
        header: "Status " + (i + 1),
        headerStyle: "width: 150px",
        isDropDownFilter: false,
        isTextFilter: false,
        isFirstUsageFilter: true,
        searchFieldType: "TRAFFIC_LIGHT",
        getter: gridhelper.renderTrafficLight
      },
    );
    lights.push(
      {
        field: "trafficLights_" + i + "_timeSpans",
        header: "Time window " + (i + 1),
        headerStyle: "width: 150px",
        isDropDownFilter: false,
        isTextFilter: false,
        isDateFilter: true,
        getter: gridhelper.renderTimeSpans
      },
    );
  }
  return lights;
}

function getActiveColumnDefinitions(trafficLightCount, fixedColumns, visibleColumns, backendColumns) {

  for (let col of backendColumns) {
    switch (_.get(col, 'displayType', 'DEFAULT')) {
      case 'TRAFFIC_LIGHT':
        col.getter = gridhelper.renderTrafficLight;
        break;
      case 'BOOLEAN':
        col.getter = gridhelper.renderBoolean;
        break;
      case 'CURRENCY':
        col.getter = gridhelper.renderCurrency;
        break;
      default:
        col.getter = gridhelper.renderDefault;
    }

  }

  let allColumns = backendColumns;
  let colMap = new Map();
  for (let col of allColumns) {
    colMap.set(col.field, col);
  }
  let res = [];
  for (let fieldName of fixedColumns) {
    if (colMap.has(fieldName)) {
      res.push(colMap.get(fieldName));
    }
  }
  let tls = generateTrafficLightCols(trafficLightCount);
  res = res.concat(tls);
  for (let field of visibleColumns) {
    if (!fixedColumns.includes(field.fieldName)) {
      if (colMap.has(field.fieldName)) {
        let f = colMap.get(field.fieldName);
        f.header = field.fieldLabel;
        f.key = field.fieldName + counter++;
        res.push(f);
      }
    }
  }
  return res;
}

export {getActiveColumnDefinitions}
